import * as S from './AllInclusiveDetailed.styles';
import GreenTickIcon from '@stencil/icons/src/GreenTickIcon/GreenTickIcon';
import {useSelector} from 'react-redux';
import {
  inclusiveRatePlanInclusionsSelector,
  inclusiveRatePlanSelector,
} from '@stencil/hotels-cg-reducer/src/details/selectors';
import AllInclusiveIcon from '@stencil/icons/src/AllInclusiveIcon/AllInclusiveIcon';

const AllInclusiveDetailed = ({onBookInclusiveCtaClick = () => {}}) => {
  const inclusionsList = useSelector(inclusiveRatePlanInclusionsSelector);
  const inclusionsData = useSelector(inclusiveRatePlanSelector);

  const {title, persuasionText} = inclusionsData;

  if (!inclusionsList.length) return null;

  return (
    <S.InclusiveWrapper>
      <S.BkIncModalHeader>
        <h3>{title}</h3>
      </S.BkIncModalHeader>
      <S.BkIncModalInfo>
        <AllInclusiveIcon />
        <span>{persuasionText}</span>
      </S.BkIncModalInfo>
      <S.BkIncModalContent className="bkIncModalContent">
        <S.BkIncModalBody>
          {inclusionsList?.map((data, index) => (
            <div id={`inclusive-${index + 1}`}>
              {data?.imageUrl && (
                <img
                  src={data.imageUrl}
                  alt={data.code}
                  className="bkIncModal__img"
                  id={data.code}
                />
              )}
              <h4 className="font18 latoBlack blackText appendBottom15">{data.code}</h4>
              <S.BkIncModalList>
                {data?.bulletTexts?.map(point => (
                  <li className="bkIncModal__list--item">
                    <span className="bkIncModal__list--itemIcon">
                      <GreenTickIcon />
                    </span>
                    <span>{point}</span>
                  </li>
                ))}
              </S.BkIncModalList>
            </div>
          ))}
        </S.BkIncModalBody>
      </S.BkIncModalContent>
      <S.BkIncModalFooter>
        <a className="bookInclusiveBtn" onClick={() => onBookInclusiveCtaClick()}>
          View All Inclusive Rate plans
        </a>
      </S.BkIncModalFooter>
    </S.InclusiveWrapper>
  );
};

export default AllInclusiveDetailed;
